// Info.tsx
import { FunctionComponent, useState } from 'react';
import styled from 'styled-components';
import Icon from '../global/Icon';
import Colors from '../global/Colors';
import Tooltip from './Tooltip';

interface InfoProps {
  text?: string;
  sub_text?: string;
  size?: number;
  colorMode?: 'light' | 'dark';
  tooltipColorMode?: 'light' | 'dark';
  position?: 'top' | 'bottom' | 'left' | 'right';
}

const InfoWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  vertical-align: middle;
  padding: 0;
  margin: 0;
`;

const Info: FunctionComponent<InfoProps> = ({
  text,
  sub_text,
  size = 16,
  colorMode = 'dark',
  tooltipColorMode = 'dark',
  position = 'top',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  const iconColor = colorMode === 'light' ? Colors.grey4 : Colors.grey6;

  return (
    <Tooltip
      text={text}
      sub_text={sub_text}
      colorMode={tooltipColorMode || colorMode}
      position={position}
      open={isOpen}
    >
      <InfoWrapper
        onClick={handleToggle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Icon 
          icon="info" 
          size={size} 
          color={iconColor} 
        />
      </InfoWrapper>
    </Tooltip>
  );
};

export default Info;